const routes = {
    home: '/',
    login: '/login',
    register: '/register',
    dashboard: '/dashboard',
    dashboardUser: 'user',
    newMessage: 'user/newmessage',
    freeMessages: 'user/freemessages',
    pendingMessages:'user/pendingmessages',
    myMessages: 'user/myMessages',
    historial: 'user/history',
    newContact: 'user/newcontact',
    listContacts: 'user/contacts',
    groups: 'user/groups',
    newLink: 'user/newlink',
    links: 'user/links',
    admin: 'admin',
    approvedMessage: 'user/approvemessage',
    addcredits: 'user/addcredits',
    authmessages:'user/list-auth-messages',
    reset_password: '/reset-password'
}

export default routes;